"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Phabricator = function Phabricator(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.076 7.644c-.408.165-.48.196-.488.213-.014.034-.01.77.006 1.116l.015.295-.223.22-.223.219-.192-.005a26.198 26.198 0 0 0-1.125.003c-.127.012-.122.01-.15.075-.12.286-.37.91-.37.922 0 .008.016.035.034.06.043.059.459.472.69.688l.24.224.057.052.002.313.003.313-.383.384c-.38.379-.519.525-.575.606l-.028.042.21.495c.2.47.213.496.235.502.07.02.287.024.84.02l.578-.005.224.226.226.226v.328c0 .503.018.96.041 1.069l.008.037.495.21c.272.114.499.208.504.208.041 0 .556-.508.926-.914l.07-.079.321.005.32.005.392.39c.43.425.63.61.664.61.004 0 .228-.089.496-.196.413-.165.489-.198.495-.214.022-.053.019-.582-.006-1.118l-.014-.292.223-.221.223-.222.268.007c.33.009 1.03.003 1.108-.009a.195.195 0 0 0 .065-.019c.014-.014.396-.955.396-.974a.273.273 0 0 0-.048-.074c-.06-.074-.452-.462-.693-.686l-.231-.215-.047-.045-.004-.314-.004-.314.364-.362c.368-.366.522-.53.588-.621l.036-.05-.211-.493a7.793 7.793 0 0 0-.223-.5.6.6 0 0 0-.104-.017 19.066 19.066 0 0 0-1.136-.003l-.18.006-.23-.225-.23-.226v-.329c0-.526-.019-.978-.043-1.075l-.01-.037-.487-.207a13.455 13.455 0 0 0-.505-.207c-.022 0-.12.082-.244.204-.184.182-.411.415-.586.602l-.175.186-.315-.005-.315-.005-.33-.329c-.487-.483-.692-.67-.738-.668-.01 0-.234.088-.497.194zm2.063 2.938c.69.09 1.237.639 1.318 1.319.015.126.005.364-.02.483a1.541 1.541 0 0 1-1.301 1.204c-.087.013-.32.013-.408 0a1.537 1.537 0 0 1-1.219-.941 1.516 1.516 0 0 1 .893-1.984 1.68 1.68 0 0 1 .32-.08c.102-.015.305-.015.417 0zm-.551-7.91a9.29 9.29 0 0 0-3.033.652 9.226 9.226 0 0 0-2.93 1.873c-.129.122-4.872 4.884-4.941 4.96a2.813 2.813 0 0 0-.674 1.549c-.013.11-.013.474 0 .585a2.79 2.79 0 0 0 .602 1.46c.09.113.14.163 3.153 3.188 1.538 1.544 1.764 1.768 2.044 2.021a9.261 9.261 0 0 0 6.871 2.349 9.225 9.225 0 0 0 5.67-2.489c.175-.162 4.881-4.886 4.973-4.991.361-.412.59-.93.663-1.502.019-.157.019-.5-.001-.657a2.79 2.79 0 0 0-.662-1.502 779.59 779.59 0 0 0-4.953-4.967 9.228 9.228 0 0 0-4.145-2.266 9.499 9.499 0 0 0-1.68-.256 15.207 15.207 0 0 0-.957-.008zm.82 1.928c.754.04 1.507.2 2.253.484.272.103.716.316.995.476a7.445 7.445 0 0 1 3.235 3.774 7.45 7.45 0 0 1 .26 4.513 7.395 7.395 0 0 1-6.443 5.53c-.34.032-.838.042-1.144.02-1.744-.116-3.3-.781-4.57-1.953a7.412 7.412 0 0 1-2.32-6.37 7.38 7.38 0 0 1 1.56-3.704 7.374 7.374 0 0 1 3.532-2.436A7.373 7.373 0 0 1 12.41 4.6z"
  }));
};

Phabricator.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Phabricator.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Phabricator;
exports.default = _default;